import clsx from 'clsx';

import useStyles from './PortalStyles';
import SideNav from '../side-nav/SideNav';
import TopNav from '../top-nav/TopNav';
import useSideNavState from '../../stores/SideNavStateStore';
import useIsPrinting from '../../utilities/PrintUtilities';

import '../panels';
import '../filters';
import Toasts from '../alerts/Toasts';
import Pages from './Pages';
import { MenuContextProvider } from '../side-nav';
import AuthorizedUserGuard from '../auth/AuthorizedUserGuard';
import AppPlmsListProvider from '../app/AppPlmsListProvider';
import Ng1NavErrorManager from '../ng1-comm/Ng1NavErrorManager';

export default function Portal() {
    const [sideNavState] = useSideNavState();
    const classes = useStyles();
    const isPrinting = useIsPrinting();

    return (
        <AuthorizedUserGuard>
            <Ng1NavErrorManager>
                <AppPlmsListProvider>
                    <MenuContextProvider>
                        <div className="flex-container">
                            <TopNav />
                            <div className="flex-container">
                                {isPrinting ? null : <SideNav />}
                                <main
                                    className={clsx('flex-container', classes.content, {
                                        [classes.contentShift]:
                                            sideNavState.open && !sideNavState.floating && !isPrinting,
                                    })}
                                >
                                    <Toasts />
                                    <Pages />
                                </main>
                            </div>
                        </div>
                    </MenuContextProvider>
                </AppPlmsListProvider>
            </Ng1NavErrorManager>
        </AuthorizedUserGuard>
    );
}
